import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import axios from "axios";
import "./BarGraph.css";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarGraph = ({ filters }) => {
  const [chartData, setChartData] = useState(null);
  const [toggleType, setToggleType] = useState("BR");
  const [fetchedData, setFetchedData] = useState(null);

  useEffect(() => {
    const hasFilters = filters && Object.values(filters).some(value => value !== "");

    if (hasFilters) {
      const fetchGraphData = async () => {
        try {
          const response = await axios.get("https://api-usersreport-insights.haqdarshak.com/api/getGraphData", {
            params: filters,
          });

          console.log("Fetched Graph Data:", response.data); // ✅ Confirm backend is sending everything
          setFetchedData(response.data);
        } catch (error) {
          console.error("Error fetching graph data:", error);
        }
      };

      fetchGraphData();
    } else {
      setFetchedData(null);
      setChartData({
        labels: [],
        datasets: [
          {
            label: "Total Application in BR_DI",
            data: [0],
            backgroundColor: "rgba(75, 192, 192, 0.7)",
          },
          {
            label: "Total Application in BR_DFL",
            data: [0],
            backgroundColor: "rgba(255, 99, 132, 0.7)",
          },
          {
            label: "Total Application in BR_YC",
            data: [0],
            backgroundColor: "rgba(153, 102, 255, 0.7)",
          },
        ],
      });
    }
  }, [filters]);

  useEffect(() => {
    if (fetchedData) {
      const { labels } = fetchedData;
  
      const dataPrefix = toggleType === "Open" ? "Open" : toggleType.toUpperCase();
  
      const getDataArray = (key) =>
        fetchedData[`${dataPrefix}_${key}`] || new Array(labels.length).fill(0);
  
      const summedDI = getDataArray("DI").map((value, index) =>
        parseInt(value || 0, 10) + parseInt(getDataArray("MSME")[index] || 0, 10)
      );
  
      setChartData({
        labels,
        datasets: [
          {
            label: `Total Application in ${dataPrefix}_DI`,
            data: summedDI,
            backgroundColor: "rgba(75, 192, 192, 0.7)",
          },
          {
            label: `Total Application in ${dataPrefix}_DFL`,
            data: getDataArray("DFL"),
            backgroundColor: "rgba(255, 99, 132, 0.7)",
          },
          {
            label: `Total Application in ${dataPrefix}_YC`,
            data: getDataArray("YC"),
            backgroundColor: "rgba(153, 102, 255, 0.7)",
          },
        ],
      });
    }
  }, [toggleType, fetchedData]);
  

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: { size: 12 },
        },
      },
      title: {
        display: true,
        text: "Monthly Work Done",
        font: { size: 18, weight: "bold" },
        padding: { top: 10, bottom: 20 },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Months",
          font: { size: 14, weight: "bold" },
        },
        ticks: {
          autoSkip: false,
          maxRotation: 60,
          minRotation: 30,
        },
      },
      y: {
        title: {
          display: true,
          text: "Applications",
          font: { size: 14, weight: "bold" },
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="bar-graph-container">
      <div className="toggle-buttons1">
        
        <button
          className={toggleType === "Open" ? "active" : ""}
          onClick={() => setToggleType("Open")}
        >
          Open
        </button>
        <button
          className={toggleType === "DS" ? "active" : ""}
          onClick={() => setToggleType("DS")}
        >
          DS
        </button>
        <button
          className={toggleType === "BR" ? "active" : ""}
          onClick={() => setToggleType("BR")}
        >
          BR
        </button>
      </div>

      {chartData ? (
        <Bar data={chartData} options={options} />
      ) : (
        <p className="no-data">No data available. Apply filters to view the graph.</p>
      )}
    </div>
  );
};

export default BarGraph;
